module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-26.d6343e11.png";